// 致命を弾いた時の演出「白黒＋接点へ寄る＋スロー」(2026-10-14 ユーザー答え・配布版の既定)。
//   ユーザー (10-14・見本3案を見て):「白黒で接点に寄ってスローにできない？」
//   元の要望 (10-14):「通常パリィの白黒っぽくなるみたいに脳汁の出るアクションゲームっぽい演出を入れたい」
//   10-09:「エフェクトと言うよりカメラの寄りとかフラッシュとか揺れとかで重さを表現してほしい」
//   見本と調べ = docs/research/2026-10-14-exec-parry-fx-refs.md (案1 白黒の上位版＋案3 スロー を土台にした)。
//   記録 = docs/research/2026-10-14-exec-parry-fx-build.md・直し (1014c) = docs/research/2026-10-14-exec-parry-fx-1014c.md。
//
// 1014c の直し (10-14 パック 1014b の答え):
//   A-6「差を付けなくてよい」→ 全ボス同じ 1 つの値 (EXEC_SLOW_UNIFIED・止めも EXEC_SLOW_STOP_MS で全ボス同じ)。
//   A-3「少しもたつく」→ ゆっくりの間に攻撃・パリィ・回避を押したら、その場で普通の速さへ戻す (execSlowCutNow)。
//       押さなければ長さは今まで通り (A-2「ちょうどいい」)。見た目 (白黒・寄り・縁) は押した所から素早く引く。
//
// 流れ (時間は弾いた瞬間からの「実時間」ms):
//   ① 止め (EXEC_SLOW_STOP_MS): 普段のパリィの白黒 (src/parry_kesaki_fx.ts・致命の弾きにも出す) と白い火花・紫の髪。
//      弾いた瞬間に画面が 3 コマだけ白く光り、接点が白くにじむ。カメラは接点へ寄り切る。
//   ② スロー (止め明けから): 押し返される動きを slow 倍で見せる。白黒は少し戻して grayKeep まで残し、画面の縁を暗くする。
//   ③ 戻り: rampMs かけて普通の速さへ。速さが戻り始める瞬間に押された向きへ一突き揺れ、寄りと白黒と縁の暗さが引く。
//   古い金の光 (exec_parry_glow の描画・金の雲・画面の金) は出さない。ただし光の残りの印 (pw) は
//   弾いた瞬間のボス・主人公の位置と押す向きを持っているので、この演出の手がかりとしてそのまま使う。
//
// 比較 (DEV ?execParryFx=… / window.__setExecParryFx(…)・URL を読むのは game.ts の DEV の箱の中だけ):
//   new (既定) = 1014c。全ボス同じ値・押したらスローを切る・白黒は短く (約 0.25 秒・10-15 ユーザー パック 1014c B-1「短い」)。
//   grayNow    = new の白黒を 1014c の長さ (約 0.67 秒) に戻す。
//   grayMid    = new の白黒を中くらい (約 0.45 秒・ゼンゼロの極限支援くらい)。
//   grayShort  = 既定と同じ (約 0.25 秒・URL の互換で残す)。
//   b1014      = 10-14b の版 (ボスごとの重さの段・押してもスローは切れない)。
//   old / now  = 10-14 より前の配布版 (白黒なし・金の光・c の寄り/金/揺れ)。
// 規則: 線・輪・放射状の筋は描かない (塗りだけ)。速い明滅をしない。
import type { FxEvent } from './types'
import { pushWeightSpec } from './exec_push_weight'

export type ExecParryFxVersion = 'new' | 'b1014' | 'old'
export type ExecGrayVariant = 'now' | 'mid' | 'short'
export const EXEC_PARRY_FX_DEFAULT: ExecParryFxVersion = 'new'
export const EXEC_GRAY_DEFAULT: ExecGrayVariant = 'short'
let version: ExecParryFxVersion = EXEC_PARRY_FX_DEFAULT
let grayVariant: ExecGrayVariant = EXEC_GRAY_DEFAULT
/** 'old' / 'now' = 前の配布版・'b1014' = 10-14b・'grayNow' / 'grayMid' / 'grayShort' = 白黒の長さ違い。それ以外は既定の new。 */
export function setExecParryFx(value: string | null | undefined): ExecParryFxVersion {
  const v = typeof value === 'string' ? value.toLowerCase() : ''
  version = v === 'old' || v === 'now' ? 'old' : v === 'b1014' ? 'b1014' : EXEC_PARRY_FX_DEFAULT
  grayVariant = v === 'graynow' ? 'now' : v === 'graymid' ? 'mid' : v === 'grayshort' ? 'short' : EXEC_GRAY_DEFAULT
  cut = null
  return version
}
export function execParryFxVersion(): ExecParryFxVersion { return version }
export function execGrayVariant(): ExecGrayVariant { return grayVariant }
/** 白黒＋寄り＋スローの演出か (new・b1014)。 */
export function execParryFxNew(): boolean { return version !== 'old' }
/** 全ボス同じ値・押したらスローを切る (1014c・new だけ)。 */
export function execParryFxUnified(): boolean { return version === 'new' }
/** いまの版の言葉 (開発版の知らせ用)。 */
export function execParryFxLabel(): string {
  if (version === 'old') return '前の版 (金の光)'
  if (version === 'b1014') return '10-14b の版 (ボスごとの段・押しても切れない)'
  return grayVariant === 'mid' ? '既定＋白黒 中 (約0.45秒)' : grayVariant === 'now' ? '既定＋白黒 1014c の長さ (約0.67秒)' : '既定 (全ボス同じ・押すとスローが切れる・白黒 約0.25秒)'
}

export type ExecSlowSpec = {
  /** 止め (ms)。c の値 (呼ぶ側が渡す)。 */
  stopMs: number
  /** スローの倍率 (0.25 = 4 分の 1 の速さ)。 */
  slow: number
  /** スローを保つ実時間 (ms・止め明けから)。 */
  slowMs: number
  /** 普通の速さへ戻る実時間 (ms)。 */
  rampMs: number
  /** 接点へ寄る量 (0.10 = 10% 大きく見せる)。 */
  zoom: number
  /** 弾いた瞬間の画面の白 (3 コマ) の強さ。 */
  flash: number
  /** 接点のにじんだ白の強さと半径。 */
  contact: number; contactR: number
  /** スローの間の画面の縁の暗さ。 */
  vignette: number
  /** スローの間に残す白黒の濃さ (0〜1)。 */
  grayKeep: number
  /** 速さが戻る瞬間の揺れ (px)。 */
  shakePx: number
}

type Tier = Omit<ExecSlowSpec, 'stopMs'>
/** 10-14b の版: ボスの重さの段 (軽い順 = 花嫁 < 騎士 < 戴冠獣 < 介錯 < 覚醒王・c と同じ並び)。DEV ?execParryFx=b1014 で残す。 */
export const EXEC_SLOW_BY_BOSS: Record<string, Tier> = {
  bride:                 { slow: 0.35, slowMs: 200, rampMs: 120, zoom: 0.06, flash: 0.25, contact: 0.45, contactR: 120, vignette: 0.28, grayKeep: 0.5, shakePx: 3 },
  'vigil-knight':        { slow: 0.25, slowMs: 300, rampMs: 150, zoom: 0.10, flash: 0.35, contact: 0.55, contactR: 150, vignette: 0.36, grayKeep: 0.55, shakePx: 6 },
  'dream-hound':         { slow: 0.23, slowMs: 330, rampMs: 150, zoom: 0.11, flash: 0.38, contact: 0.58, contactR: 155, vignette: 0.38, grayKeep: 0.58, shakePx: 7 },
  'the-executioner':     { slow: 0.21, slowMs: 370, rampMs: 160, zoom: 0.12, flash: 0.42, contact: 0.6, contactR: 160, vignette: 0.42, grayKeep: 0.6, shakePx: 8 },
  'crowned-king-awoken': { slow: 0.2, slowMs: 420, rampMs: 170, zoom: 0.14, flash: 0.5, contact: 0.65, contactR: 170, vignette: 0.45, grayKeep: 0.62, shakePx: 9 },
}
/**
 * 1014c の既定: 全ボス同じ 1 つの値 (A-6「差を付けなくてよい」)。
 *   10-14b の段の真ん中 = 騎士の値をそのまま使う (長さは A-2「ちょうどいい」なので大きく変えない。
 *   一番遅かった覚醒王 0.2 倍 420ms は無くなり、一番浅かった花嫁 0.35 倍 200ms も無くなる)。
 */
export const EXEC_SLOW_UNIFIED: Tier = { ...EXEC_SLOW_BY_BOSS['vigil-knight'] }
/** 1014c の止め (ms・全ボス同じ)。10-14b の段 c の騎士と同じ 100ms。 */
export const EXEC_SLOW_STOP_MS = 100
/** 押してスローを切った時に普通の速さへ戻す実時間 (ms・約 2 コマ)。 */
export const EXEC_SLOW_CUT_RAMP_MS = 34

export function execSlowSpec(bossId: string, stopMs: number): ExecSlowSpec {
  if (execParryFxUnified()) return { stopMs: EXEC_SLOW_STOP_MS, ...EXEC_SLOW_UNIFIED }
  return { stopMs, ...(EXEC_SLOW_BY_BOSS[bossId] ?? EXEC_SLOW_BY_BOSS['vigil-knight']) }
}
/** 致命を弾いた時の止め (hits.ts から)。1014c は全ボス同じ、それ以外は渡された段の値のまま。 */
export function execSlowStopMs(stageMs: number): number {
  return execParryFxUnified() ? EXEC_SLOW_STOP_MS : stageMs
}

/** 白黒を全部の濃さで保つ実時間 (ms)。普段のパリィ (6 コマ) より長く、止めより少し長く。 */
const GRAY_FULL_MIN_MS = 133
const GRAY_FULL_AFTER_STOP_MS = 40
const GRAY_TO_KEEP_MS = 120
const GRAY_OUT_EXTRA_MS = 120
const ZOOM_IN_MS = 70
const ZOOM_OUT_EXTRA_MS = 250
const FLASH_HOLD_MS = 50, FLASH_FADE_MS = 50
const CONTACT_FADE_MS = 120
const VIGNETTE_IN_MS = 150, VIGNETTE_OUT_EXTRA_MS = 100
const SHAKE_DECAY_MS = 220

const smooth = (t: number) => { const x = Math.max(0, Math.min(1, t)); return x * x * (3 - 2 * x) }
const easeOut = (t: number) => { const x = Math.max(0, Math.min(1, t)); return 1 - (1 - x) * (1 - x) }

// ---- 時間 (ゲームの時間 ↔ 実時間) -----------------------------------------------------------
// 止め明けからのゲームの ms (g) と実時間の ms (r)。スローの間 g = slow × r、戻りの間は速さが slow→1 へ直線で上がる。

/** 止め明けからのゲームの ms での速さの倍率 (game.ts の state.timeScale)。 */
export function execSlowScaleAtGame(gMs: number, s: ExecSlowSpec): number {
  if (gMs < 0) return 1
  if (gMs === 0) return s.slow
  const g1 = s.slow * s.slowMs
  if (gMs <= g1) return s.slow
  const x = execSlowRealOfGame(gMs, s) - s.slowMs
  if (x >= s.rampMs) return 1
  return s.slow + (1 - s.slow) * (x / s.rampMs)
}
/** 止め明けからのゲームの ms → 実時間の ms。 */
export function execSlowRealOfGame(gMs: number, s: ExecSlowSpec): number {
  if (gMs <= 0) return 0
  const g1 = s.slow * s.slowMs
  if (gMs <= g1) return gMs / s.slow
  const g2 = (s.slow + 1) / 2 * s.rampMs
  const d = gMs - g1
  if (d >= g2) return s.slowMs + s.rampMs + (d - g2)
  // s·x + (1−s)·x²/(2R) = d を x について解く。
  const a = (1 - s.slow) / (2 * s.rampMs)
  if (a <= 0) return s.slowMs + d / s.slow
  const x = (-s.slow + Math.sqrt(s.slow * s.slow + 4 * a * d)) / (2 * a)
  return s.slowMs + x
}
/** 弾いた瞬間からの実時間 (ms・止めの中も数える)。ageSec = ゲームの時刻での経過 (止めの間は 0)。 */
export function execSlowClockMs(ageSec: number, hitStopRemainingSec: number, s: ExecSlowSpec): number {
  if (ageSec <= 1e-6 && hitStopRemainingSec > 0) return Math.max(0, s.stopMs - hitStopRemainingSec * 1000)
  return s.stopMs + execSlowRealOfGame(Math.max(0, ageSec) * 1000, s)
}
/** 全部が収まるまでの実時間 (ms)。 */
export function execSlowTotalMs(s: ExecSlowSpec): number {
  const rel = s.stopMs + s.slowMs
  return Math.max(rel + s.rampMs + ZOOM_OUT_EXTRA_MS, rel + s.rampMs + GRAY_OUT_EXTRA_MS, rel + SHAKE_DECAY_MS)
}

// ---- 見え方の強さ (r = 弾いてからの実時間 ms) ------------------------------------------------
const releaseAt = (s: ExecSlowSpec) => s.stopMs + s.slowMs

/** 白黒の長さ違い (grayMid / grayShort): 全部の濃さで保つ ms と、そこから消えるまでの ms。 */
export const EXEC_GRAY_SHAPE: Record<Exclude<ExecGrayVariant, 'now'>, { fullMs: number; fadeMs: number }> = {
  mid: { fullMs: 140, fadeMs: 310 },    // 約 0.45 秒で消える (ゼンゼロ 極限支援: 白黒 13 コマ＋戻り 14〜17 コマ ≒ 0.47 秒)
  short: { fullMs: 100, fadeMs: 150 },  // 約 0.25 秒で消える (普段のパリィ: 6 コマ＋6 コマ ≒ 0.2 秒)
}
/** 画面の白黒の濃さ (0〜1)。 */
export function execSlowGray(r: number, s: ExecSlowSpec): number {
  if (r < 0) return 0
  const rel = releaseAt(s)
  const out = (x: number) => 1 - smooth((x - rel) / (s.rampMs + GRAY_OUT_EXTRA_MS))
  if (grayVariant !== 'now' && execParryFxUnified()) {
    const g = EXEC_GRAY_SHAPE[grayVariant]
    const hold = r < g.fullMs ? 1 : 1 - smooth((r - g.fullMs) / g.fadeMs)
    return r < rel ? hold : hold * out(r)
  }
  const full = Math.max(GRAY_FULL_MIN_MS, s.stopMs + GRAY_FULL_AFTER_STOP_MS)
  const hold = (x: number) => x < full ? 1 : 1 - (1 - s.grayKeep) * smooth((x - full) / GRAY_TO_KEEP_MS)
  return r < rel ? hold(r) : hold(rel) * out(r)
}
/** 寄りの倍率 (1 = 寄らない)。止めの中で寄り切り、速さが戻り始めてから引く。 */
export function execSlowZoom(r: number, s: ExecSlowSpec): number {
  if (r < 0) return 1
  const rel = releaseAt(s)
  const k = r < rel ? easeOut(r / ZOOM_IN_MS) : 1 - smooth((r - rel) / (s.rampMs + ZOOM_OUT_EXTRA_MS))
  return 1 + s.zoom * k
}
/** 弾いた瞬間の画面全体の白 (0〜1・3 コマ保って 3 コマで消える)。 */
export function execSlowFlash(r: number): number {
  if (r < 0) return 0
  if (r < FLASH_HOLD_MS) return 1
  return 1 - smooth((r - FLASH_HOLD_MS) / FLASH_FADE_MS)
}
/** 接点のにじんだ白 (0〜1・止めの間は保ち、明けて CONTACT_FADE_MS で消える)。 */
export function execSlowContact(r: number, s: ExecSlowSpec): number {
  if (r < 0) return 0
  if (r <= s.stopMs) return 1
  const k = (r - s.stopMs) / CONTACT_FADE_MS
  return k >= 1 ? 0 : (1 - k) * (1 - k)
}
/** 画面の縁の暗さ (0〜1)。 */
export function execSlowVignette(r: number, s: ExecSlowSpec): number {
  if (r < 0) return 0
  const rel = releaseAt(s)
  if (r < rel) return smooth(r / VIGNETTE_IN_MS)
  return 1 - smooth((r - rel) / (s.rampMs + VIGNETTE_OUT_EXTRA_MS))
}
/** 速さが戻る瞬間の揺れ ({x, y} px)。dir = 押される向き (+1 = 右)。押す向きへ一突きして小さく返る。 */
export function execSlowShake(r: number, s: ExecSlowSpec, dir: number): { x: number; y: number } {
  const t = r - releaseAt(s)
  if (t < 0 || t >= SHAKE_DECAY_MS || s.shakePx <= 0) return { x: 0, y: 0 }
  const u = t / SHAKE_DECAY_MS
  const env = (1 - u) * (1 - u)
  return { x: dir * s.shakePx * env * Math.cos(1.6 * Math.PI * u), y: 0.25 * s.shakePx * env }
}

// ---- 手がかり (光の残りの印) ------------------------------------------------------------------
type Glow = Extract<FxEvent, { kind: 'exec_parry_glow' }>
/** いま効いている致命の弾き (一番新しい・印 pw 付き)。新しい版の時だけ。 */
export function activeExecSlowGlow(fx: readonly FxEvent[], now: number): Glow | undefined {
  if (!execParryFxNew()) return undefined
  let f: Glow | undefined
  for (const e of fx) if (e.kind === 'exec_parry_glow' && e.pw && now >= e.t && (!f || e.t >= f.t)) f = e
  return f
}

// ---- 押したらスローを切る (1014c・A-3「少しもたつく」) -----------------------------------------
// どの弾き (印の t) を、止め明けからのゲームの何 ms で切ったか。新しい弾きが来たら t が変わるので前の分は効かない。
let cut: { t: number; gMs: number } | null = null
export function _resetExecSlowCut(): void { cut = null }
/**
 * ゆっくりの間 (止めの中を含む) に攻撃・パリィ・回避が押されたら呼ぶ。切ったら true。
 *   止めの中で押した時は止め明けにスローへ入らず、そのまま普通の速さで進む。new (1014c) だけ。
 */
export function execSlowCutNow(fx: readonly FxEvent[], now: number): boolean {
  if (!execParryFxUnified()) return false
  const f = activeExecSlowGlow(fx, now)
  if (!f || (cut && cut.t === f.t)) return false
  const s = baseSpecOf(f)
  if (!s) return false
  const g = Math.max(0, (now - f.t) * 1000)
  if (g >= s.slow * s.slowMs) return false   // もう戻りに入っている (戻りは短いのでそのまま)
  cut = { t: f.t, gMs: g }
  return true
}

function baseSpecOf(f: Glow): ExecSlowSpec | null {
  if (!f.pw) return null
  const pw = pushWeightSpec(f.pw.v, f.pw.bossId)
  return pw ? execSlowSpec(f.pw.bossId, pw.hitStopMs) : null
}
/** その弾きの決まり (止めの長さ = 1014c は全ボス同じ・b1014 は印の版の段 c の値)。押して切った時はスローをそこで終わらせ、素早く戻す。 */
export function execSlowSpecOf(f: Glow): ExecSlowSpec | null {
  const s = baseSpecOf(f)
  if (!s || !cut || cut.t !== f.t) return s
  const cutR = execSlowRealOfGame(cut.gMs, s)
  // 止めの中で押した時 (cutR = 0) はスローへ一切入らない (速さ 1 のまま・見た目だけ止め明けから引く)。
  if (cutR <= 0) return { ...s, slow: 1, slowMs: 0, rampMs: EXEC_SLOW_CUT_RAMP_MS }
  return cutR < s.slowMs ? { ...s, slowMs: cutR, rampMs: EXEC_SLOW_CUT_RAMP_MS } : s
}
/**
 * game.ts の state.timeScale (= 次の 1 コマぶんのゲームの時間を、実時間の何倍で進めるか)。
 *   止めが入るコマ (hitStopMs > 0) は 1 (止めは普通の速さで見せる)。止めの最後のコマでも呼ぶ (game.ts の止めの早い戻り)
 *   = 止めが明けた最初のコマからスローになる。now = いまのゲームの時刻 (次のコマはここから進む)。
 */
export function execSlowTimeScale(fx: readonly FxEvent[], now: number, hitStopMs: number): number {
  if (hitStopMs > 0) return 1
  const f = activeExecSlowGlow(fx, now)
  const s = f ? execSlowSpecOf(f) : null
  if (!f || !s) return 1
  const g = (now - f.t) * 1000
  if (g < 0) return 1
  return execSlowScaleAtGame(g, s)
}

// ---- 描く (render.ts から・画面座標) ------------------------------------------------------------
/** 接点のにじんだ白 (加算・輪郭なし)。 */
export function drawExecSlowContact(ctx: CanvasRenderingContext2D, sx: number, sy: number, level: number, s: ExecSlowSpec): void {
  if (level <= 0.003) return
  const R = s.contactR, a = s.contact * level
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  const g = ctx.createRadialGradient(sx, sy, 0, sx, sy, R)
  g.addColorStop(0, `rgba(246,244,255,${a.toFixed(3)})`)
  g.addColorStop(0.35, `rgba(232,228,255,${(a * 0.35).toFixed(3)})`)
  g.addColorStop(1, 'rgba(220,214,255,0)')
  ctx.fillStyle = g
  ctx.fillRect(sx - R, sy - R, R * 2, R * 2)
  ctx.restore()
}
/** 画面全体の白 (弾いた瞬間だけ) と縁の暗さ (スローの間)。 */
export function drawExecSlowScreen(ctx: CanvasRenderingContext2D, w: number, h: number, sx: number, sy: number,
  flash: number, vignette: number, s: ExecSlowSpec): void {
  ctx.save()
  if (vignette > 0.003) {
    const a = s.vignette * vignette
    const g = ctx.createRadialGradient(sx, sy, Math.min(w, h) * 0.28, sx, sy, Math.max(w, h) * 0.75)
    g.addColorStop(0, 'rgba(6,4,14,0)')
    g.addColorStop(0.55, `rgba(6,4,14,${(a * 0.45).toFixed(3)})`)
    g.addColorStop(1, `rgba(6,4,14,${a.toFixed(3)})`)
    ctx.globalCompositeOperation = 'source-over'
    ctx.fillStyle = g
    ctx.fillRect(0, 0, w, h)
  }
  if (flash > 0.003) {
    ctx.globalCompositeOperation = 'source-over'
    ctx.fillStyle = `rgba(246,246,255,${(s.flash * flash).toFixed(3)})`
    ctx.fillRect(0, 0, w, h)
  }
  ctx.restore()
}
